// extracted by mini-css-extract-plugin
export default {"container":"AdvancementPagePlaceholder__container___OP7Ow","org":"AdvancementPagePlaceholder__org___Uj6YU"};